import React from 'react'
import PropTypes from 'prop-types'

import SwiperCore, { Navigation, Pagination, Scrollbar } from 'swiper/core'
import { Swiper, SwiperSlide } from 'swiper/react'

import {
  SLIDE_CONTAINER_WIDTH,
  SLIDE_SPACE_BETWEEN,
  SLIDE_SPEED,
  SWIPER_KINDS,
  SWIPER_SCROLLBAR_DATA,
} from 'Constants/Swipers'

import { Container, Content } from './styles'

import CtoSlide from '../CtoSlide'
import Slide from '../ProjectSlide'
import SwiperScrollbar from '../SwiperScrollbar'
import TestimonialSlide from '../TestimonialSlide'

// Scoped here rather than in the root layout: as a layout import this was
// the only render-blocking stylesheet on every route, swiper page or not.
import 'swiper/swiper-bundle.css'

// eslint-disable-next-line react-hooks/rules-of-hooks
SwiperCore.use([Navigation, Pagination, Scrollbar])

function SwiperNarrow({ data, kind }) {
  if (!data) return null

  return (
    <Container>
      <Content>
        <Swiper
          autoHeight
          grabCursor
          scrollbar={{
            el: `.${SWIPER_SCROLLBAR_DATA.el}--${kind}`,
            dragClass: `${SWIPER_SCROLLBAR_DATA.dragClass}--${kind}`,
            draggable: true,
            snapOnRelease: true,
          }}
          slidesPerView={1}
          spaceBetween={SLIDE_SPACE_BETWEEN.narrow}
          speed={SLIDE_SPEED}
        >
          {data.map(item => (
            <SwiperSlide key={`${item.id}slideNarrow`}>
              {kind === SWIPER_KINDS.PROJECTS && <Slide project={item} />}

              {kind === SWIPER_KINDS.TESTIMONIALS && (
                <TestimonialSlide data={item} />
              )}

              {kind === SWIPER_KINDS.CTOS && <CtoSlide person={item} />}
            </SwiperSlide>
          ))}
        </Swiper>
      </Content>

      <SwiperScrollbar modifier={`--${kind}`} width={SLIDE_CONTAINER_WIDTH} />
    </Container>
  )
}

SwiperNarrow.defaultProps = {
  data: [],
  kind: SWIPER_KINDS.PROJECTS,
}

SwiperNarrow.propTypes = {
  data: PropTypes.array,
  kind: PropTypes.oneOf([
    SWIPER_KINDS.PROJECTS,
    SWIPER_KINDS.TESTIMONIALS,
    SWIPER_KINDS.CTOS,
  ]),
}

export default SwiperNarrow
